import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0">
        <video
          src="https://y-f-s.jp/img/hero.mp4"
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1a2332]/85 via-[#1a2332]/65 to-[#1a2332]/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 pt-32 pb-20">
        <div className="max-w-3xl">
          <span className="inline-block text-xs font-semibold tracking-[3px] text-white/60 uppercase mb-6">
            Consulting Services
          </span>
          <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6">
            中小企業の<br />
            持続的成長を支える
          </h1>
          <p className="text-2xl md:text-3xl font-medium text-white/90 mb-8">
            集客・営業支援コンサルティング
          </p>
          <p className="text-base md:text-lg text-white/75 leading-relaxed max-w-xl mb-12">
            企業の売上基盤の強化を目的に、集客戦略の構築から営業体制の整備まで
            一貫して支援するコンサルティング会社です。
            実務に基づいた改善提案と継続的な運用支援により、
            安定した収益構造の構築をサポートいたします。
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/services"
              className="px-8 py-4 bg-white text-[#1a2332] font-semibold rounded-lg hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
            >
              サービスを見る
            </Link>
            <Link
              to="/contact"
              className="px-8 py-4 border-2 border-white text-white font-semibold rounded-lg hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
            >
              お問合せ
            </Link>
          </div>
        </div>

      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50">
        <span className="text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-px h-12 bg-gradient-to-b from-white/50 to-transparent" />
      </div>
    </section>
  );
}
